import type { UserSubscriptionTier } from "./types/userDashboard"

export const PRICING_TIERS = [
  {
    tier: 1,
    quantity: 0,
  },
  {
    tier: 2,
    quantity: 50,
  },
  {
    tier: 3,
    quantity: 100,
  },
  {
    tier: 4,
    quantity: 250,
  },
  {
    tier: 5,
    quantity: 500,
  },
  {
    tier: 6,
    quantity: 1000,
  },
  {
    tier: 7,
    quantity: 2500,
  },
  {
    tier: 8,
    quantity: 5000,
  },
  {
    tier: 9,
    quantity: 7500,
  },
  {
    tier: 10,
    quantity: 10000,
  },
  {
    tier: 11,
    quantity: 15000,
  },
] as const

export const MAX_AVAILABLE_TIER = Math.max(
  ...PRICING_TIERS.map((tier) => tier.tier),
)

export const subscriptionTiers: Record<
  UserSubscriptionTier,
  {
    minTier: number | null
    maxTier: number | null
  }
> = {
  TIER_10: {
    minTier: null,
    maxTier: 3,
  },
  TIER_20: {
    minTier: 2,
    maxTier: 7,
  },
  TIER_30: {
    minTier: 4,
    maxTier: null,
  },
}
